package es.subastia

import androidx.compose.animation.Crossfade
import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import coil3.ImageLoader
import coil3.compose.setSingletonImageLoaderFactory
import coil3.network.ktor3.KtorNetworkFetcherFactory
import es.subastia.auctiondetail.AuctionDetailScreen
import es.subastia.auctionlist.AuctionFilterScreen
import es.subastia.auctionlist.AuctionListScreen
import es.subastia.gallery.GalleryScreen
import es.subastia.main.MainScreen
import es.subastia.navigation.BindBackHandler
import es.subastia.navigation.NavRoute
import es.subastia.navigation.Navigator
import es.subastia.splash.SplashScreen
import es.subastia.ui.theme.DarkGradientEnd
import es.subastia.ui.theme.DarkGradientStart
import es.subastia.ui.theme.LightGradientEnd
import es.subastia.ui.theme.LightGradientStart
import es.subastia.ui.theme.SubastiaTheme
import org.koin.compose.koinInject

@Composable
fun App() {
    setSingletonImageLoaderFactory { context ->
        ImageLoader.Builder(context)
            .components {
                add(KtorNetworkFetcherFactory())
            }
            .build()
    }

    val navigator: Navigator = koinInject()
    val backstack by navigator.backstack.collectAsState()
    val currentRoute = backstack.lastOrNull()

    SubastiaTheme {
        BindBackHandler(isEnabled = backstack.size > 1) {
            navigator.pop()
        }
        val backgroundGradient = Brush.verticalGradient(
            colors = if (isSystemInDarkTheme()) {
                listOf(DarkGradientStart, DarkGradientEnd)
            } else {
                listOf(LightGradientStart, LightGradientEnd)
            },
        )
        Surface(
            modifier = Modifier.fillMaxSize(),
            color = MaterialTheme.colorScheme.background,
        ) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(backgroundGradient),
            ) {
                if (currentRoute != null) {
                    Crossfade(targetState = currentRoute) { route ->
                        when (route) {
                            is NavRoute.Splash -> SplashScreen(navigator)
                            is NavRoute.Main,
                            is NavRoute.SavedSearches,
                            is NavRoute.Favorites,
                            is NavRoute.Profile,
                            is NavRoute.AuctionList -> MainScreen(navigator)
                            is NavRoute.AuctionDetail -> AuctionDetailScreen(navigator, route.id)
                            is NavRoute.AuctionFilter -> AuctionFilterScreen(navigator)
                            is NavRoute.Gallery -> GalleryScreen(navigator, route.imageUrl)
                        }
                    }
                }
            }
        }
    }
}
